// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"5027d2d6","453":"20359781"}[chunkId] + ".chunk.js";
};